import { getPrefixedVar } from '@private/payment';
import styled, { css } from 'styled-components';

import Typography from 'components/Typography';

const prefix = ['components', 'rightSidebar'];

export const Container = styled.div<{
  $isOpen: boolean;
  $size: 'lg' | 'md' | 'xl' | 'xxl';
}>`
  position: fixed;
  right: ${({ $isOpen }) => ($isOpen ? '0px' : '-700px')};
  top: 0;
  bottom: 0;
  height: 100vh;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 22px ${getPrefixedVar(prefix, 'shadow')};
  background: ${getPrefixedVar(prefix, 'bg')};
  z-index: 52;

  ${({ $size }) => {
    if ($size === 'lg') {
      return css`
        width: 500px;
      `;
    }

    if ($size === 'xl') {
      return css`
        width: 700px;
      `;
    }

    if ($size === 'xxl') {
      return css`
        width: 900px;
      `;
    }

    return css`
      width: 360px;
    `;
  }}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 16px;
  padding: 21px 20px;
`;

export const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  column-gap: 12px;
`;

export const Title = styled(Typography)`
  color: ${getPrefixedVar(prefix, 'header', 'title')};
`;

export const Subtitle = styled(Typography)`
  color: ${getPrefixedVar(prefix, 'header', 'subtitle')};
`;

export const HeaderActions = styled.div`
  display: flex;
  column-gap: 12px;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  column-gap: 12px;
  padding: 32px 20px 20px;
`;

export const SidebarBody = styled.div`
  flex: 1 1 auto;
  overflow: hidden auto;
  scrollbar-gutter: stable;
`;
